export default __webpack_public_path__ + "ad1f81d261b882b28011eefda024761e.svg";